import { post, get, put } from "./api_helper";
import * as url from "./url_helper";
import authHeader from "./jwt-token-access/auth-token-header";

// Login Method
export const postLogin = (data) => post(url.POST_LOGIN, data);
export const getSettings = () => get(url.GET_SETTINGS);

// Register
export const postRegister = (data) => post(url.REGISTER_ARTIST, data);
//change password
export const putChangePassword = (data) => post(url.putChangePassword, data);
// top Artist
export const postTopArtist = (data) => post(url.POST_TOP_ARTIST, data);

// File
export const postFile = (data) => {
  const formData = new FormData();

  Object.entries(data).map(([key, value]) => formData.append(key, value));

  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };

  return post(url.POST_FILE, formData, config);
};
export const postMultiFile = (data) => {
  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };

  return post(url.POST_MULTI_FILE, data, config);
};

export const postIpfsFile = (data) => {
  const formData = new FormData();
  Object.entries(data).map(([key, value]) => formData.append(key, value));
  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };

  return post(url.POST_IPFS_FILE, formData, config);
};

// User
export const getCurrentUser = () => get(url.GET_CURRENT_USER);
export const putProfileApi = (data) => post(url.PUT_PROFILE, data);
export const putProfileImage = (data) => {
  const formData = new FormData();
  Object.entries(data).map(([key, value]) => formData.append(key, value));

  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };
  return post(url.PUT_PROFILE_IMAGE, formData, config);
};
export const getUserByWallet = (walletAddress) =>
  get(url.GET_USER_BY_WALLET + walletAddress);
export const userAllNftCountApi = (data) => post(url.USER_ALL_NFT, data);
// Homepage
export const getHomepage = (data) => post(url.GET_HOMEPAGE, data);
export const getMostlyView = (data) => post(url.GET_MOSTLY_VIEW, data);
export const getLatest = (data) => post(url.GET_LATEST, data);
export const getTopCollections = (data) => post(url.GET_TOP_COLLECTIONS, data);
export const getExplore = (data) => post(url.GET_EXPLORE, data);
export const getSecondrySale = (data) => post(url.GET_SECONDRY_SALE, data);
export const postFollow = (data) => post(url.POST_FOLLOW, data);
export const getFollow = (data) => post(url.GET_FOLLOW, data);

//  FORGET PASSWORD

export const postForget = (data) => post(url.POST_FORGET, data);
export const postReset = (data) => post(url.POST_RESET, data);
export const postVerifyOtp = (data) => post(url.POST_OTP, data);

//  SUBSCRIBE
export const postSubscribe = (data) => post(url.POST_SUBSCRIBE, data);

// onPostNewsLetter
export const postNewletter = (data) => post(url.POST_NEWLETTER, data);

// export const artistSubmission = (data) => post(url.)
// verify email 
export const emailVerify = (data) => post(url.EMAIL_VERIFY, data)
export const emailVerifyAgain = (data) => post(url.EMAIL_VERIFY_AGAIN, data)
// particular user 
export const getParticularUserApi = (id) => get(url.PARTICULAR_USER_API+"/"+id)

// Collection
export const getCollectionNameVerify = (name) =>
  get(url.GET_COLLECTION_NAME_VERIFY + name);
export const getCollectionBytecode = (data) =>
  post(url.GET_COLLECTION_BYTECODE, data);
export const getCollections = (data) => get(url.GET_COLLECTIONS, data);
export const postCollection = (data) => post(url.POST_COLLECTION, data);
export const postNewCollectionApi = (data) => post(url.POST_NEW_COLLECTION, data);
export const getCollection2 = () => get(url.GET_COLLECTION2);
export const getNewCollectionByEmail = (data) => post(url.GET_NEW_COLLECTIONS_BY_EMAIL, data);
export const deleteNewCollectionapi = (data) => post(url.DELETE_NEW_COLLECTION, data);
// export const getCollection = (_id) => get(url.GET_COLLECTION + _id);
export const getCollection = () => get(url.GET_COLLECTION);
export const getCollectionByAddress = (_id) =>
  get(url.GET_COLLECTION_BY_ADDRESS + _id);
export const putCollection = (data) => post(url.PUT_COLLECTION, data);
export const putNewCollectionByIdApi = (data) => post(url.PUT_NEW_COLLECTION_BY_ID, data);
export const getNewCollectionByIdApi = (id) => get(url.GET_NEW_COLLECTION_BY_ID + id);
export const getCollectionByIdApi = () => get(url.GET_COLLECTION);
export const getAllNewCollectionsApi = () => get(url.GET_ALL_NEW_COLLECTIONS);
export const getAllNewCollectionsWithFilterApi = (data) => post(url.GET_ALL_NEW_COLLECTIONS_WITH_FILTER, data);
//new collection
// export const postNewCollectionApi = (data) => post(url.POST_NEW_COLLECTION, data);
// export const getCollection2 = () => get(url.GET_COLLECTION2);
// Category
export const getCategories = (data) => post(url.GET_CATEGORIES, data);
export const getNewcategories = () => get(url.CATEGORIES);
export const getSubcategoriesApi = (data) => post(url.SUB_CATEGORIES, data);
// Item
export const likeViewCountApi = (data) => post(url.LIKE_VIEW, data);
export const getItems = (data) => post(url.GET_ITEMS, data);
export const postItem = (data) => post(url.POST_ITEM, data);
export const putItem = (data) => put(url.PUT_ITEM, data);
export const getItemByToken = (token) => get(url.GET_ITEM_BY_TOKEN + token);
export const postItemSale = (data) => post(url.POST_ITEM_SALE, data);
export const getActivities = (data) => post(url.GET_ACTIVITIES, data);
export const postItemBuy = (data) => post(url.POST_ITEM_BUY, data);
export const postFavourite = (data) => post(url.POST_FAVOURITE, data);
export const getFavourite = (data) => post(url.GET_FAVOURITE, data);
export const getItem = (id) => get(url.GET_ITEM + id);
export const getSearchData = (id) => get(url.GET_SEARCH + id);
export const postToggleItemSale = (data) =>
  post(url.POST_TOGGLE_ITEM_SALE, data);
export const nftFromCollectionApi = (data) => post(url.NFT_FROM_COLLECTION, data);
export const postUpcomingAuction = (data) => post(url.POST_UPCOMING, data);
export const getItemByIdApi = (id) => get(url.GET_ITEM_BY_ID + id);
export const getCurrentOwerItemsApi = (current_owner) => post(url.CURRNET_OWNER, current_owner);
// // File
// export const postFile = (data) => {
//   const formData = new FormData();

//   Object.entries(data).map(([key, value]) => formData.append(key, value));

//   const config = {
//     headers: { ...authHeader(), "content-type": "multipart/form-data" },
//   };

//   return post(url.POST_FILE, formData, config);
// };
export const AddArtApi = (data) => {
  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };
  return post(url.POST_ART_FILE, data, config);
};
/* Bids */
export const postBid = (data) => post(url.POST_BID, data);
export const deleteBid = (data) => post(url.DELETE_BID, data);
export const postBidAction = (data) => post(url.POST_BID_ACTION, data);
export const getBids = (data) => post(url.GET_BIDS, data);

// Faq
export const getFaqs = () => get(url.GET_FAQS);

// Content Pages
export const getContentPage = () => get(url.GET_CONTENT_PAGE);

export const getImages = () => get(url.GET_IMAGES);

//  Report Abuse

export const reportAbuse = (data) => post(url.REPORT_ABUSE, data);
// Contact Us
export const postContactUs = (data) => post(url.POST_CONTACT_US, data);
export const getNotifications = (data) => post(url.GET_NOTIFICATIONS, data);
export const putNotifications = (data) => post(url.PUT_NOTIFICATIONS, data);
//new
export const getArtNotificationApi = (data) => post(url.GET_ART_NOTIFICATION, data);
export const updateArtNotificationApi = (data) => post(url.UPDATE_GET_ART_NOTIFICATION, data);
export const postNotificationApi = (data) => post(url.POST_NOTIFICATION_API, data);
export const sendNewsLetterEmailApi = (data) => post(url.SEND_NEWSLETTER_EMAIL_API, data);
export const verifyNewsLetterEmailApi = (data) => post(url.VERIFY_NEWSLETTER_EMAIL_API, data);
//request for verification
export const requestForVarification = (data) =>
  get(url.REQUEST_FOR_VARIFICATION);

export const requestForCollectoinVarification = (data) =>
  post(url.REQUEST_FOR_COLLECTOIN_VARIFICATION, data);

//get blogs
export const getBlogs = (data) => get(url.GET_BLOGS);
export const getBlogsById = (data) => get(url.GET_BLOGS_BYID + data);

// art page
export const postArtApi = (data) => post(url.POST_ART, data);
export const getArtByUserIdApi = (data) => get(url.GET_ART_BY_USER_ID + data);

// get museums

export const getAllMuseumsApi = () => get(url.GET_ALL_MUSEUMS);
export const getTopMuseumApi = () => get(url.GET_TOP_MUSEUMS);

export const getTopArtistApi = () => get(url.GET_TOP_ARTIST);
export const getAllArtistApi = (data) => post(url.GET_ALL_ARTIST_URL, data);

// owner

export const fetchOwnerApi = (data) => post(url.GET_OWNER, data);
export const addOwnerApi = (data) => post(url.ADD_OWNER, data);
export const updateOwnerApi = (data) => post(url.UPDATE_OWNER, data);
export const getAllOwnerApi = (data) => post(url.GET_ALL_OWNER, data);
export const getviewCountApi = (id) => get(url.GET_VIEW_COUNT + id);
export const likeViewApi = (data) => post(url.LIKE_VIEW_SELLITEM, data);
export const allSellItemFromCollectionIdApi = (data) => post(url.ALL_SELL_ITEM_FROM_COLLECTION, data);
export const allSellItemNftCountApi = (data) => post(url.ALL_SELL_ITEM_NFT_COUNT, data);
export const allSellItemCurrentOwnerApi = (data) => post(url.ALL_SELL_ITEM_CURRENT_OWNER_URL, data);
export const getTopSaleApi = (data) => post(url.GET_TOP_SALES_OWNER_URL, data);



// sell item
export const fetchSellItemApi = (id) => get(url.GET_SELL_ITEM + id);
export const addSellItemApi = (data) => post(url.ADD_SELL_ITEM, data);
export const updateSellItemApi = (data) => post(url.UPDATE_SELLITEM, data);
export const getAllSellItemApi = (data) => post(url.GET_ALL_SELL_ITEM, data);
export const topSellItemApi = (data) => post(url.TOP_SELL_ITEM_URL, data);
export const sellItemFromCollectionIdApi = (id) => get(url.SELL_ITEM_FROM_COLLECTION_ID + id);
export const trendingArtworkApi = (data) => post(url.TRENDING_ARTWORK_URL, data);
export const recentListingApi = (data) => post(url.RECENT_LISTING_URL, data);
export const exploreListingApi = (data) => post(url.EXPLORE_LISTING_URL, data);

// transaction
export const fetchTransactionApi = (id) => get(url.GET_TRANSACTION + id);
export const addTransactionApi = (data) => post(url.ADD_TRANSACTION, data);
export const getAllTransactionApi = (data) => post(url.GET_ALL_TRANSACTION, data);
export const getAllTransactionFromUserIdApi = (data) => post(url.GET_ALL_TRANSACTION_FROM_USERID, data);
export const getUserEarningFromUserIdApi = (data) => post(url.GET_USER_EARNING_FROM_USERID, data);


// referrals

export const getUserReferralsApi = (data) => post(url.GET_USER_REFERRALS_URL, data);
export const sendReferralMailApi = (data) => post(url.SEND_REFERRAL_MAIL_URL, data);
export const getUserRedeemsApi = (data) => post(url.GET_USER_REDEEM_URL,data)

// print

export const addPrintRequestApi = (data) => post(url.ADD_PRINT_REQUEST,data)
export const getPinterProductApi = (data) => post(url.GET_PRINTER_PRODUCT,data)
export const getPrintRequestsFormUserIdApi = (data) => post(url.GET_PRINT_REQUESTS_URL,data)

// print transction 
export const addPrintTransApi = (data) => post(url.ADD_PRINT_TRANS_URL,data)
export const addArtworkFormApi = (data) => post(url.ADD_ARTWORK_FORM_URL,data)
export const getArtworkFormApi = (data) => post(url.GET_ARTWORK_FORM_URL,data)   
export const getPrintReqOwnerApi = (data) => post(url.GET_PRINT_REQUEST_FORM_OWNER_URL,data) 
export const polygonSiginUserApi = (data) => post(url.GET_POLYGON_USER_QR,data) 
export const polygonAuthUpdateApi = (id) => get(url.POLYGON_AUTH_UPDATE_URL+id) 
export const getPrinterListApi = (data) => get(url.PRINTER_LIST_URL, data) 
export const getCanvasPaperSizeApi = (data) => post(url.PAPER_CANVAS_SIZE_URL, data) 


export const GetCheckoutIntentApi = (data) => post(url.GET_CHECK_INTENT_URL, data) 

export const postWithdrawRequestSellerApi = (data) => post(url.WITHDRAW_REQUEST_SELLER_URL, data) 
export const printReqTransFailApi = (data) => post(url.PRINT_REQUEST_TRANS_URL, data) 



export const postCustomArtApi = (data) => post(url.POST_CUSTOM_ART_URL, data) 
export const listCustomArtApi = (data) => post(url.GET_CUSTOM_ART_LIST_URL, data) 
